import {ReceiptLong} from '@mui/icons-material'
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const getSalesRecord = () => ({
    id: 'salesRecord',
    type: 'group',
    children: [
        {
            id: 'salesRecord',
            title: i18n.t('sidemenu.salesRecordsManagement'),
            type: 'item',
            url: '/salesRecord',
            icon: ReceiptLong,
            breadcrumbs: false,
        },
    ]
});

export default getSalesRecord;